module.exports = __webpack_public_path__ + "static/media/Properties.5f260381.png";